<div class="w-[380px] bg-pl-gray-200 rounded-lg flex flex-col items-center gap-4 p-6 h-full">
  <div class="relative block h-[183px] w-[207px]">
    <pl-icon
      [name]="color === CertificateColor.blue ? PlIcon.certificate_blue : PlIcon.certificate_green"
      class="w-full h-full"
    />
    <h3 class="absolute top-[60px] left-1/2 -translate-x-1/2 mx-auto text-pl-orange-500">{{ certificateName }}</h3>
  </div>
  <h4>{{ title }}</h4>
  @if (lockedMessage) {
    <p class="text-center">{{ lockedMessage }}</p>
  } @else {
    <pl-button
      class="!w-fit"
      [isDisabled]="disableButton()"
      [variant]="ButtonVariant.lightOrange"
      (click)="generateCertificate()"
    >
      {{ buttonTitle }}
    </pl-button>
  }
</div>
